import { ASetPlaylistMw, TPlaylistMw } from '../actions/playlists-mw.action';
import { TRemote } from '../actions';
import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';



const playlistMwListeners = [
  TPlaylistMw.FETCH_PLAYLIST_MW,
  TRemote.SET_REMOTE
];

let playlistMwEpicTimeout = 0;


export const fetchPlaylistMwEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => playlistMwListeners.includes(type)),
    filter(() => new Date().getTime() - playlistMwEpicTimeout > 2000),
    tap(() => playlistMwEpicTimeout = new Date().getTime()),
    mergeMap(() => restApi.get('/library/playlists?ngsw-bypass=true', 15000).pipe(
      /**
       * There is a common handler for all errors.
      * However, we need to return an empty array in case of an error
      * to prevent the error from being propagated to the upper level.
      * If it is not handled here, this interrupts the flow if the API returns a 404.
       */
      catchError(() => of([])),
    )),
    map(ASetPlaylistMw)
  );
